module.exports = __webpack_public_path__ + "img/advantage1.04c66dd8.png";